import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { showsFavoritesEntityModel } from '~/entities/shows/favorites'

export const loadGridFavoritesTvShows = createEvent()

sample({
  clock: loadGridFavoritesTvShows,
  filter: not(api.tvshows.getOnlyFavoritesTvShowsGridFx.pending),
  target: api.tvshows.getOnlyFavoritesTvShowsGridFx,
})

export const $isGridFavoritesTvShowsLoading = combine(
  {
    onlyFavoritestvShowsLoading:
      api.tvshows.getOnlyFavoritesTvShowsGridFx.pending,
    onlyFavoritestvShows: showsFavoritesEntityModel.$onlyFavoritesTvShowsGrid,
  },
  ({ onlyFavoritestvShowsLoading, onlyFavoritestvShows }) =>
    !onlyFavoritestvShows && onlyFavoritestvShowsLoading
)

export const loadMoreGridFavoritesTvShows = createEvent()

sample({
  clock: loadMoreGridFavoritesTvShows,
  filter: not(api.tvshows.getOnlyFavoritesTvShowsGridFx.pending),
  fn: () => null,
  target: showsFavoritesEntityModel.loadMoreOnlyFavoritesTvShowsGrid,
})
